import ky from "ky";
import { useAuthStore } from "@/store/auth-store";

const API_URL = import.meta.env.VITE_API_URL;

function readCsrfCookie(): string {
  const match = document.cookie.match(/(?:^|;\s*)(?:csrftoken|__Secure-csrftoken)=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : "";
}

export const api = ky.create({
  prefix: API_URL,
  // Browser must send the session + CSRF cookies on every same-origin
  // call. Without this the SPA can never authenticate.
  credentials: "include",
  hooks: {
    beforeRequest: [
      ({ request }) => {
        const { locationId } = useAuthStore.getState();
        if (locationId) {
          request.headers.set("X-Location-Id", locationId);
        }
        if (request.method !== "GET" && request.method !== "HEAD") {
          const token = readCsrfCookie();
          if (token) request.headers.set("X-CSRFToken", token);
        }
      },
    ],
    afterResponse: [
      ({ response }) => {
        // Server says the session is gone (expired, revoked, browser swept).
        // Clear local hints so the guard kicks the user back to /login.
        if (response.status === 401) {
          useAuthStore.getState().logout();
        }
      },
    ],
  },
});

export async function ensureCsrfCookie(): Promise<void> {
  if (readCsrfCookie()) return;
  await api.get("auth/csrf");
}
